import React from 'react';

import FullScreenChat from '~/components/AiChat/containers/FullScreenChat';

const CliveChat: React.FC = () => {
  return (
    <div className="h-full rounded p-8">
      <FullScreenChat />
    </div>
  );
};

export default CliveChat;
